import common from './common';
import navigation from './navigation';
import settings from './settings';
import pages from './pages';

export default [
  common,
  navigation,
  settings,
  pages,
].join('');
